var accessibility = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
        $(window).on('load', function () {
            enableAccesibility();
        })
    },
    removeMouse: function () {
        removeMouseMoveFunction();
    }
}
// Adds custom class to element when traversed to using keyboard controls, mainly with tab and arrowkeys.
function enableAccesibility() {
    $('.accessibility-menu button').on('click', function(e){
        e.preventDefault();
        var $this = $(this);
        if ($this.attr('data-url')){
            window.location.href = $this.attr('data-url');
        }else if ($this.attr('data-id')){
            var target = $(`#${$this.attr('data-id')}`);
            var oldIndex = target.attr('tabIndex');
            target.attr('tabIndex','0');
            setTimeout(() => {
                target.trigger('focus');
                setTimeout(() => {
                    if (oldIndex){
                        target.attr('tabIndex',oldIndex);
                    }
                }, 5000);
            }, 50);
            
        }
        return;
    })
    
    $('body').on('keyup', ':tabbable', function(e){
        if (['Tab', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp'].indexOf(e.key) != -1){
            enableMouseMoveFunction();
        }
    });

    $(document).on('trigger:accBorder','body',function(_,selector, timeout = 0, force){
        setTimeout(() => {
            try {
                if (typeof selector == 'string'){
                    selector = $(selector);
                }
                selector.trigger('focus');   
            } catch (error) {
                //
            }
            setTimeout(() => {
                setAccessibilityborder(selector, force);    
            }, 1);
            
        }, timeout);
    });

    function setAccessibilityborder($focus, force){
        $('.access-focus-border').removeClass('access-focus-border');
        if (window.accessibilityBorderEnabled || force){
            if (!$focus){
                $focus = $(':focus');
            }
            if($focus.attr('type') == 'radio' && ($focus.closest('.shipping-method-list').length || $focus.closest('.paymentMethod').length)){
                $focus.parent().addClass('access-focus-border');
            }else if($focus.attr('type') == 'radio' && $focus.closest('.package-shop-list').length){
                $focus.closest('.details').addClass('access-focus-border');
            }else if($focus.attr('type') == 'checkbox'){
                $focus.parent().addClass('access-focus-border');
            }else{
                $focus.addClass('access-focus-border');
            }
        }
    }

    $('body').on('keypress', ':tabbable', function(e){
        if (['Escape'].indexOf(e.key) != -1){
            $('.access-focus-border').removeClass('access-focus-border');
            removeMouseMoveFunction();
        }
    });

    $('[type="radio"]').on('change',function(e){
        if ($('.access-focus-border').length){
            setAccessibilityborder($(this));
        }
    })

    window.triggerNarrator = function(textToNarrate){
        $('#statusbar').text(' ');
        setTimeout(() => {
            $('#statusbar').text(textToNarrate);    
        }, 50);
    }

    $(document).on('keypress', '[type="checkbox"]', function(e) {
        if(e.key == 'Enter'){
            $(this).trigger('click');
            e.stopPropagation();
            e.preventDefault();
        }
    });

    // $('.menu-promotion a').each(function(){
    //     let $this = $(this);
    //     if ($this.find('.menu-promotion-text').text()){
    //         $this.find('img').attr('alt','').attr('role','presentation').attr('aria-hidden','true');
    //     }
    // })

    $(document).on('change', '.coi__checkbox', function(e){
        var $t = $(this);
        setTimeout(function(){
            if ($t.is(":focus")){
                $('#show_details').trigger('focus');
            }
            setTimeout(function(){
                $t.trigger('focus');    
            },35);
            
        },150);
    })
    if ($('.coi__checkbox').length){
        $('.coi__checkbox').attr('aria-live', 'polite');
    }

    function removeMouseMoveFunction() {
        $(document).off('mousemove', 'body', removeClassOnMouseMove);
    }

    function enableMouseMoveFunction() {
        $(document).on('mousemove', 'body' ,removeClassOnMouseMove);
        window.accessibilityBorderEnabled = true;
        setAccessibilityborder();
    }

    function removeClassOnMouseMove() {
        if($('.access-focus-border').length){
            $('.access-focus-border').removeClass('access-focus-border');
        }
        window.accessibilityBorderEnabled = false;
    }

}
module.exports = accessibility;